import { useEffect, useRef, useState } from 'react';
import type { GameState, Rank } from '@cc/shared';
import { CoinSVG } from './CoinSVG';
import { Button } from './Button';

export function FlipTray({ state, interactive, selectedRank, payMode, onFlip, onCoin }: { state: GameState; interactive: boolean; selectedRank?: Rank | undefined; payMode?: boolean | undefined; onFlip: () => void; onCoin: (rank: Rank) => void }) {
  const active = state.players[state.current];
  const [flipping, setFlipping] = useState(false);
  const timer = useRef<number | null>(null);
  useEffect(() => () => { if (timer.current !== null) window.clearTimeout(timer.current); }, []);
  const startFlip = () => {
    if (!interactive || flipping) return;
    setFlipping(true);
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
    timer.current = window.setTimeout(() => {
      timer.current = null;
      setFlipping(false);
      onFlip();
    }, reducedMotion ? 150 : 2_000);
  };
  if (state.phase === 'awaitFlip') return <div className={`flip-tray flip-tray--waiting ${flipping ? 'flip-tray--flipping' : ''}`} aria-label="Coins ready to flip"><div className="flip-coins">{([1, 2, 3, 4] as const).filter((rank) => active.bank[rank] > 0).map((rank) => <span className="flip-coin" key={rank}><CoinSVG rank={rank} side={active.side} size={40 + rank * 4} /></span>)}</div><Button onClick={startFlip} disabled={!interactive || flipping}>{flipping ? 'Flipping…' : 'Flip!'}</Button></div>;
  return <div className="flip-tray" aria-label="Flip tray">{active.hand.map((coin) => {
    const matched = coin.flipped === active.side;
    return <button key={coin.uid} className={`tray-coin ${matched ? 'tray-coin--match' : 'tray-coin--miss'} ${selectedRank === coin.rank ? 'tray-coin--selected' : ''}`} disabled={!interactive || !matched} onClick={() => onCoin(coin.rank)} aria-label={`${matched ? 'Matched' : 'Missed'} rank ${coin.rank} coin${payMode ? ', select to pay' : ''}`}><CoinSVG rank={coin.rank} side={coin.flipped ?? active.side} size={42 + coin.rank * 5} /><span>{matched ? '✓' : '✕'}</span></button>;
  })}</div>;
}
